<template>
  <div class="TemperatureSensorSettings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="TemperatureSensorSettings-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="TemperatureSensorSettings-main lxn-pos-rel">
      <div class="TemperatureSensorSettings-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.TemperatureSensorSettings_title1}}
          </template>
          <template v-slot:body>
            <div class="TemperatureSensorSettings-wrapper-inputState lxn-w100">
              <div class="TemperatureSensorSettings-wrapper-inputState-d0 lxn-text" :class="[$store.getters.language.floatClass, $store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                {{$store.getters.language.texts.TemperatureSensorSettings_text1}}
              </div>
              <div v-if="isNodeOffline || isHubOffline" class="TemperatureSensorSettings-wrapper-inputState-d1 lxn-title" :class="$store.getters.language.floatClassReverse">
                <ButtonIcon :size="40" bgColor="#DEDEDE" icon="offline" iconColor="#1EA5DE" :padding="8" />
              </div>
              <div v-else class="TemperatureSensorSettings-wrapper-inputState-d1 lxn-title" :class="$store.getters.language.floatClassReverse">
                {{temperature}} °C
              </div>
            </div>
            <!-- <div class="RelaySSR2ASettings-wrapper-outputState lxn-w100">
              <div class="RelaySSR2ASettings-wrapper-outputState-right lxn-h100" :class="$store.getters.language.floatClass">
                <div class="lxn-text" :class="[$store.getters.language.floatClass, $store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                  {{$store.getters.language.texts.RelaySSR2ASettings_text1}}
                </div>
              </div>
              <div class="RelaySSR2ASettings-wrapper-outputState-left lxn-text lxn-h100" :class="$store.getters.language.floatClassReverse">
                <SingleSwitch @switchClicked="toggleShowLiveData()" :state="showLiveData" bgColorOn="#2FBAEE" bgColorOff="#FFFFFF" bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF" :disabled="isNodeOffline || isHubOffline" />
              </div>
            </div> -->
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.TemperatureSensorSettings_title2}}
          </template>
          <template v-slot:body>
            <div class="TemperatureSensorSettings-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.TemperatureSensorSettings_text3}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="inputFieldState='active'" @blur="inputFieldState=''" :inputState="inputFieldState" v-model="currentInputName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddNodeNameColor_placeHolder" inputType="text" />
            </div>
          </template>
        </TitleBox>
      </div>
      <div class="TemperatureSensorSettings-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.TemperatureSensorSettings_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import CustomInput from '@/components/CustomInput.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE6 from '@/statics/devices/Node6/header.js'

export default {
  name: 'TemperatureSensorSettings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    ButtonIcon,
  },
  data: function () {
    return {
      inputFieldState: '',
      node: this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID),
      currentInputName: '',
    }
  },
  watch: {
  },
  mounted: function () {
    this.currentInputName = this.inputName;

    var messagingHook = new Messaging(new Logger(false));
    messagingHook.init({
      psk: this.hub.psk,
      destinationUUID: this.hub.uuid,
      sourceUUID: this.$store.state.user.uuid
    });
    this.$store.dispatch('readNodeParameters', {messagingHook: messagingHook,hubUUID: this.hub.uuid,nodeUUID: this.node.uuid})
    .then( response => {
      this.$store.dispatch('processNodeParameters', {rawParameters: response.body.bodyContent.parameterList, nodeUUID: this.node.uuid});
      //TODO: check if we are still on this page or not, then enable stateUpdater
      //BUG: if you open this page and close it very fast, stateUpdater will remain active
      this.$store.commit('setHubStatus', {
        hubIndex: response.hubIndex,
        stateUpdateEnabled: true,
      });
    })
    .catch( response => {
      if(response.rejectCode == 2){
        this.$store.commit('setHubStatus', {
          hubIndex: response.hubIndex,
          connectionStatus: {
            local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
          },
        });
      }else{
        this.$store.commit('setHubStatus', {
          hubIndex: response.hubIndex,
          stateUpdateEnabled: true,
        });
      }
    });
  },
  destroyed: function () {
    this.$store.commit('cancelAllStateUpdates');
  },
  computed: {
    inputImpact: function () {
      return 0;
    },
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    input: function () {
      return this.node.inputs[this.$route.params.inputIndex];
    },
    inputName: function () {
      return this.input.name;
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    isHubOffline: function () {
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.node.color];
    },
    temperature: function () {
      var targetParameterId = NODE6.INPUT1.PARAMETER_ID;
      var temperature = this.$store.getters.getParameterValue(this.node.index, targetParameterId);
      return temperature/10;
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    saveChanges: function () {
      this.inputFieldState = '';
      if(this.currentInputName == ''){
        this.inputFieldState = 'error';
        alert(this.$store.getters.language.texts.TemperatureSensorSettings_alert);
      }else{
        this.$store.commit('setAppBusy', true);
        this.$store.commit('setNodeInputName', {nodeIndex: this.node.index, inputIndex: this.$route.params.inputIndex, name: this.currentInputName});
        this.$store.commit('saveState');
        this.$router.push('/Home/Devices');
        this.$store.commit('setAppBusy', false);
      }
    },
  }
}
</script>

<style>
  .TemperatureSensorSettings-topCurve-wrapper {
    height: 200px;
  }
  .TemperatureSensorSettings-main {
    z-index: 2;
  }
  .TemperatureSensorSettings-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .TemperatureSensorSettings-wrapper-inputState {
    height: 50px;
  }
  .TemperatureSensorSettings-wrapper-inputState-d0 {
    line-height: 50px;
  }
  .TemperatureSensorSettings-wrapper-inputState-d1 {
    line-height: 50px;
  }
  .TemperatureSensorSettings-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .TemperatureSensorSettings-wrapper-outputState {
    height: 50px;
    color: #52626C;
    line-height: 50px;
  }
  .TemperatureSensorSettings-wrapper-outputState-right {
    width: calc(100% - 84px);
  }
  .TemperatureSensorSettings-wrapper-outputState-left {
    width: 70px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .TemperatureSensorSettings-wrapper-fieldTitle:first-child {
    height: 25px;
    line-height: 25px;
    padding-top: 0;
  }
  .TemperatureSensorSettings-wrapper-fieldTitle {
    height: 35px;
    padding-top: 10px;
    line-height: 25px;
    color: #52626C;
  }
  .TemperatureSensorSettings-wrapper-condition {
    background-color: #FFFFFF;
    margin-bottom: 14px;
    padding: 10px;
  }
  .TemperatureSensorSettings-wrapper-condition:last-child {
    margin-bottom: 0;
  }
  .TemperatureSensorSettings-condition-text {
    height: 30px;
    line-height: 30px;
    margin-right: 14px;
    margin-left: 14px;
  }
  .TemperatureSensorSettings-wrapper-scenario {
    margin-top: 14px;
  }
  .TemperatureSensorSettings-scenario {
    height: 30px;
    line-height: 30px;
    margin-right: 14px;
    margin-left: 14px;
    padding-left: 14px;
    padding-right: 14px;
    background-color: #3BB878;
    color: #ffffff;
  }
  .TemperatureSensorSettings-trash {
    left: 10px;
    top: 10px;
  }
  .TemperatureSensorSettings-delay {
    line-height: 30px;
  }
  .TemperatureSensorSettings-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .TemperatureSensorSettings-wrapper-button2 {
    width: calc(100% - 36px);
    margin-top: 25px;
    margin-bottom: 14px;
  }
</style>
